import { useLocation } from "react-router-dom";
import { useMapRoutePatterToRegex } from "./routes/useMapRoutePatterToRegex";

export const useGenericViewerOpened = (url: string) => {
    
    const location = useLocation()
    const mapToRegex = useMapRoutePatterToRegex()
    return mapToRegex(url).test(location.pathname)
}